import React from 'react';
import PropTypes from 'prop-types';
import { FieldSet, KeyValue } from '../elements';
import Button from '../v2/common/components/Button';
import StatusIndicator from './StatusIndicator';

export const PIX_STATUS_INDICATOR_PROPS = {
  ATIVA: {
    label: 'Aguardando pagamento',
    color: 'gold',
    icon: 'clock',
  },
  PROCESSING: {
    label: 'Aguardando pagamento',
    color: 'gold',
    icon: 'clock',
  },
  PENDING: {
    label: 'Aguardando pagamento',
    color: 'gold',
    icon: 'clock',
  },
  CONCLUIDA: {
    label: 'Pago',
    color: 'limegreen',
    icon: 'check-circle',
  },
  ERROR: {
    label: 'Erro',
    color: 'red',
    icon: 'times-circle',
  },
  VALOR_DIVERGENTE: {
    label: 'Erro',
    color: 'red',
    icon: 'times-circle',
  },
  REMOVIDA_PELO_USUARIO_RECEBEDOR: {
    label: 'Removido pelo usuário recebedor',
    color: 'red',
    icon: 'times-circle',
  },
  REMOVIDA_PELO_PSP: {
    label: 'Removido pelo PSP',
    color: 'red',
    icon: 'times-circle',
  },
};

export const getPixStatusLabel = status => (
  PIX_STATUS_INDICATOR_PROPS[status]
    ? PIX_STATUS_INDICATOR_PROPS[status].label
    : status || '-'
);

export const PixStatusIndicator = ({ status }) => {
  const props = PIX_STATUS_INDICATOR_PROPS[status];
  if (!props) return <>{getPixStatusLabel(status)}</>;

  return (
    <StatusIndicator color={props.color} icon={props.icon}>
      <strong>{props.label}</strong>
    </StatusIndicator>
  );
};

PixStatusIndicator.propTypes = {
  status: PropTypes.string,
};

PixStatusIndicator.defaultProps = {
  status: null,
};

const PixPaymentSummary = ({
  pixData,
  showRegenerate,
  forceRegenerate,
  regenerating,
  onRegenerate,
}) => {
  if (!pixData) return null;

  const canShowRegenerate = showRegenerate && (
    forceRegenerate || pixData.can_regenerate_pix
  );

  return (
    <>
      <FieldSet title="PIX" />
      <div className="enrollment-flex">
        <KeyValue label="TXID" title={pixData.txid} />
        <div className="col-md-4 col-sm-12 mb-3">
          <h6>Situação do PIX</h6>
          <PixStatusIndicator status={pixData.status} />
        </div>
      </div>
      {canShowRegenerate && (
        <div className="w-50 mt-3">
          <Button
            disabled={regenerating}
            loading={regenerating}
            onClick={() => onRegenerate(forceRegenerate)}
          >
            Gerar novo PIX
          </Button>
        </div>
      )}
    </>
  );
};

PixPaymentSummary.propTypes = {
  pixData: PropTypes.shape({
    txid: PropTypes.string,
    status: PropTypes.string,
    can_regenerate_pix: PropTypes.bool,
  }),
  showRegenerate: PropTypes.bool,
  forceRegenerate: PropTypes.bool,
  regenerating: PropTypes.bool,
  onRegenerate: PropTypes.func,
};

PixPaymentSummary.defaultProps = {
  pixData: null,
  showRegenerate: false,
  forceRegenerate: false,
  regenerating: false,
  onRegenerate: () => null,
};

export default PixPaymentSummary;
